import projectImg from "./card.jpg";
import aboutHero from "./aboutHero.png";
import heroImage from "./heroImage.png";
import heroSlide from "./heroSlide.png";
import projectImgDetails from "./image 3.png";
import approach from "./approach_bg.png";
import notFound from "./404.jpg";
import who_we_are from "./who_we_are.png";
const images = {
  projectImg,
  aboutHero,
  heroImage,
  heroSlide,
  projectImgDetails,
  approach,
  notFound,
  who_we_are,
};

export default images;
